module.exports = __webpack_public_path__ + "static/media/fb-2d.ca0a5ccb.svg";